import React, { useEffect } from "react";
import nuvamaLogo from "../../assets/images/svg/nuvamaBlueLogo.svg";
import mobileViewImg from "../../assets/images/png/mobileViewImg.png";
import appStore from "../../assets/images/png/appStore.png";
import playStore from "../../assets/images/png/playStore.png";
import PageHeading from "../PageHeading/PageHeading";

const OrientationScreenForMobile = ({ isLandScape }) => {
  const appStoreLink =
    "https://apps.apple.com/tt/app/edelweiss-private-wealth/id1581367179";
  const playStoreLink =
    "https://play.google.com/store/apps/details?id=com.edelweiss.app&hl=en_IN&gl=US";

  const playStoreUrl = `https://play.app.goo.gl/?link=https://play.google.com/store/apps/details?id=com.edelweiss.app`;

  // const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
  const isAndroid = /Android/.test(navigator.userAgent);

  const appScheme = "nuvamaprivate://";

  // const deepLink = (link) => {
  //   try {
  //     if ((isAndroid && link === playStoreUrl) || (isIOS && appStoreLink === link)) {
  //       const appScheme = 'nuvamaprivate://'
  //       if (!isIOS) {
  //         window.location.href = appScheme;
  //         setTimeout(() => {
  //           window.location.href = link;
  //         }, 500);
  //       } else window.location.href = link;
  //     } else {
  //       window.location.href = link;
  //     }
  //   } catch (e) {
  //     alert(`${e}`)
  //   }
  // }

  function redirectToAppStore() {
    window.location.href = appStoreLink;
  }

  function redirectToPlayStore() {
    if (isAndroid) window.location.href = playStoreUrl;
    else window.location.href = playStoreLink;
  }

  useEffect(() => {
    window.location.href = appScheme;
  }, []);

  return (
    <div className={`corientation_screen_for_mobile`}>
      <img
        className={`nuvama_logo ${isLandScape ? "landscape" : "portrait"}`}
        src={nuvamaLogo}
        alt="Nuvama"
      />
      <div
        className={`mobile_view_main_container ${
          isLandScape ? "landscape" : "portrait"
        }`}
      >
        <img className="mobile_view_person_img" src={mobileViewImg} alt="" />
        <div className="mobile_view_text_container">
          <div className="mobile_view_text_container_one">
            <PageHeading
              headingClass="serve_you_better_text"
              headingText={"We intend to serve you better"}
            />
            <span className="serve_you_better_subtext">
              To get the best mobile experience, we recommend you to go ahead
              and download our mobile app.{" "}
            </span>
          </div>
          <div className="mobile_view_text_container_two">
            <h5 className="download_here_text">Download it here</h5>
            <div className="playstore_appstore_logo_wrapper">
              <button
                onClick={redirectToAppStore}
                style={{
                  width: "151px",
                  height: "50px",
                  background: "transparent",
                  border: "none",
                }}
              >
                <img src={appStore} alt="App Store" />
              </button>
              {/* <a
                onClick={redirectToAppStore}
                // href={false ? appStoreLink : appScheme}
              >
                <img src={appStore} alt="App Store" />
              </a> */}
              <button
                onClick={redirectToPlayStore}
                style={{
                  width: "151px",
                  height: "50px",
                  background: "transparent",
                  border: "none",
                }}
              >
                <img src={playStore} alt="Play Store" />
              </button>
              {/* <a
                // href="https://play.google.com/store/apps/details?id=com.edelweiss.app&hl=en_IN&gl=US"
                // href="https://onelink.to/hkseqf"
                // href={playStoreUrl}
                onClick={redirectToPlayStore}
              >
                <img src={playStore} alt="Play Store" />
              </a> */}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default OrientationScreenForMobile;
